import React from 'react';

type Props = {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
  error?: string;
};

export default function AddressSelect({ label, value, onChange, options, error }: Props) {
  return (
    <div className='flex flex-col'>
      <label className='text-sm font-medium text-gray-700'>{label}</label>
      <select
        value={value}
        onChange={onChange}
        className={`mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:outline-none focus:ring-1 sm:text-sm
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'}`}
      >
        <option value=''>Select {label}</option>
        {options.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <p className='mt-1 text-xs text-red-600'>{error}</p>}
    </div>
  );
}
